import type { FC } from "react";

import { DropdownMenuCheckboxItemWithStatus } from "@/components/atoms";
import { formatTestId } from "@/utils/formatTestId";

import type { StatusVariants } from "../types";

interface StatusSubMenuProps {
  category: string;
  toggleItem: (category: string, item: string) => void;
  statusVariantMap: StatusVariants;
  subMenus: Record<string, string[]>;
  selectedMap: Record<string, string[]>;
}

const StatusSubMenu: FC<StatusSubMenuProps> = ({
  subMenus,
  toggleItem,
  statusVariantMap,
  selectedMap,
  category,
}) => {
  return (
    subMenus[category]?.map(item => {
      const variant = statusVariantMap[item];
      const testId = `status-submenu-item-${formatTestId(item)}`;

      return (
        <DropdownMenuCheckboxItemWithStatus
          key={item}
          checked={selectedMap[category]?.includes(item) || false}
          onCheckedChange={() => {
            toggleItem(category, item);
          }}
          indicatorColor={variant?.dot}
          data-testid={testId}
        >
          <span className="text-sm">{item}</span>
        </DropdownMenuCheckboxItemWithStatus>
      );
    }) ?? null
  );
};

export default StatusSubMenu;
